<p class="title">
  {{ 'MANAGE_VACATIONS.RESUME_TEXT' | translate }}
</p>
<app-momo-proposal-card
  [proposal]="proposal"
  [canEdit]="false"
  [showWinterSlots]="showWinterSlots"
  [proposalIndex]="proposalIndex"></app-momo-proposal-card>
